import React, { FunctionComponent } from 'react';
import ErrorPage from 'app/components/pages/ErrorPage';
import HttpStatusPageContent from 'app/components/pages/HttpStatusPageContent';

interface IProps {
  status: number;
  header?: string;
  message?: string;
}

const HttpStatusPage: FunctionComponent<IProps> = ({ status, header, message }) => (
  <ErrorPage status={status} title={`${status}`}>
    <HttpStatusPageContent
      status={status}
      header={header || ''}
      message={message || ''}
    />
  </ErrorPage>
);

export default HttpStatusPage;
